(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/app/frejaeid/assets/javascripts/frejaeid.js') >= 0) return;  svs.modules.push('/components/app/frejaeid/assets/javascripts/frejaeid.js'); (function(svs) {
  var ACTION_TYPE = {
    SUSPENSION: 0,
    SUBSCRIPTION: 1
  };

  function frejaeidErrorHandler(actionType, xhr) {
    var errorCode, errorMessage;
    if (svs.utils.ns.isNamespace('responseJSON.error.code', xhr || {})) {
      errorCode = xhr.responseJSON.error.code;
    }
    switch (errorCode) {
      case 1:
        if (actionType === ACTION_TYPE.SUSPENSION) {
          errorMessage = 'Det går inte att verifiera din identitet just nu, var vänlig försök igen lite senare eller kontakta Kundservice 0770 - 11 11 11';
        } else {
          errorMessage = 'Det går inte att skapa autogiromedgivande just nu, var vänlig försök igen lite senare eller kontakta Kundservice 0770 - 11 11 11';
        }
        break;
      case 51: 
        svs.app.frejaeid.logger.debug('User cancelled');
        var message = '';
        if (actionType === ACTION_TYPE.SUSPENSION) {
          message = 'Bekräftelse av spelpaus avbröts';
        } else {
          message = 'Skapandet av autogiromedgivande avbröts';
        }
        var _alert = new svs.components.dialog.Confirm({
          area: svs.components.dialog.area.TOASTER,
          type: svs.components.dialog.type.ERROR,
          autoClose: svs.components.dialog.autoClose.MEDIUM,
          title: message,
          actions: [
            {
              title: 'OK'
            }
          ]
        });
        svs.components.dialog.api.add(_alert); 
        break;
      default:
        svs.app.frejaeid.logger.error('Unhandle freja eid error', xhr);
        if (actionType === ACTION_TYPE.SUSPENSION) {
          errorMessage = 'Det går inte att verifiera din identitet just nu, var vänlig försök igen lite senare eller kontakta Kundservice 0770 - 11 11 11';
        } else {
          errorMessage = 'Det går inte att skapa autogiromedgivande just nu, var vänlig försök igen lite senare eller kontakta Kundservice 0770 - 11 11 11';
        }
    }
    if (errorMessage) {
      var loggerInfo = '';
      var title = '';
      if (actionType === ACTION_TYPE.SUSPENSION) {
        loggerInfo = 'Suspension request with frejaeid failure';
        title = 'Misslyckad verifiering';
      } else {
        loggerInfo = 'Direct debit permission request with frejaeid failure';
        title = 'Misslyckat autogiromedgivande';
      }
      svs.app.frejaeid.logger.info(loggerInfo);
      var _dialog = new svs.components.dialog.Confirm({
        branding: svs.components.dialog.branding.TUR,
        type: svs.components.dialog.type.ERROR,
        title: title,
        message: [
          {
            type: svs.components.dialog.message.TEXT,
            text: errorMessage
          }
        ],
        actions: [
          {
            title: 'OK'
          }
        ]
      });
      svs.components.dialog.api.add(_dialog); 
    }
  }

  function showFrejaEidProgress(options, successFn, errorFn, context, response) {
    var checker = new svs.app.frejaeid.Checker({
      authRef: response.authRef
    });
    checker.model.once('change:postToken', function(model, value) {
      svs.components.Modal.hide();
      successFn && successFn.call(context, { postToken: value });
    });
    checker.model.once('change:error', function(model, value) {
      svs.components.Modal.hide();
      errorFn.call(context, value);
    });
    svs.components.Modal.show(
      svs.app.frejaeid.views.FrejaEid,
      {
        model: checker.model,
        authRef: response.authRef
      },
      {
        title: options.title,
        leftButton: {
          text: 'Avbryt',
          callback: function() {
            checker.stopPolling();
            errorFn.call(context, {
              responseJSON: {
                error: {
                  code: 51 
                }
              }
            });
            return true;
          }
        },
        rightButton: {
          visible: false
        }
      }
    );
    setTimeout(function() {
      checker.startPolling();
    }, 2000);
  }
  function authenticate(options, successFn, errorFn, context) {
    var errFn =
      errorFn ||
      function(xhr) {
        frejaeidErrorHandler(ACTION_TYPE.SUSPENSION, xhr);
      };
    options = options || {};
    options.title = options.title || 'Bekräfta spelpaus';
    this.initAuth(showFrejaEidProgress.bind(this, options, successFn, errFn, context), errFn);
  }
  function initAuth(successFn, errorFn) {
    var errFn =
        errorFn ||
        function(xhr) {
          frejaeidErrorHandler(ACTION_TYPE.SUSPENSION, xhr);
        },
      succFunc =
        successFn ||
        function() {
          svs.app.frejaeid.logger.info('Successfully initAuth for Freja eID');
        };
    svs.core.jupiter.call(
      {
        path: '/player/frejaeid/initauthsign',
        method: 'POST',
        data: {},
        context: this
      },
      succFunc,
      errFn
    );
  }
  function getFrejaEidStartParams(authRef) {
    var url,
      logger = svs.core.log.getLogger('app:frejaeid');
    if (svs.core.detect.os.android()) {
      url = 'frejaeid://bindUserToTransaction?transactionReference=' + authRef;
    } else if (svs.core.detect.formfactor.desktop()) {
      url = 'frejaeid://bindUserToTransaction?transactionReference=' + authRef;
    } else if (svs.core.detect.os.iOS()) {
      url = 'frejaeid://bindUserToTransaction?transactionReference=' + authRef;
    } else {
      url = 'frejaeid://bindUserToTransaction?transactionReference=' + authRef + '&originAppScheme=' + getReturnUrl(authRef);
    }
    logger.debug('Freja eID start url: ' + url);
    return url;

  }
  function getReturnUrl() {
    var returnUrl,
      logger = svs.core.log.getLogger('app:frejaeid'),
      userAgentFamily = svs.app.frejaeid.data.useragent_family,
      isNativeApp = svs.utils.ns.isNamespace('svs.core.config.data.svsconfig.isNativeApp', window) && svs.core.config.data.svsconfig.isNativeApp;

    if (svs.core.detect.browser.crios()) {
      if (window.location.protocol.indexOf('s') > -1) {
        returnUrl = 'googlechromes://';
      } else {
        returnUrl = 'googlechrome://';
      }
    } else {
      if (svs.core.detect.os.iOS()) {
        if (isNativeApp) {
          returnUrl = encodeURIComponent(window.location.href.replace(/https?/i, svs.core.detect.tenant('tb') ? 'spelbutiken.bankid' : 'spelbutikenlb.bankid'));
        } else if (userAgentFamily.indexOf('firefox') > -1) {
          returnUrl = encodeURIComponent('firefox://open-url?url=' + svs.utils.url.currentUrlEncodedParams());
        } else if (userAgentFamily.indexOf('safari') > -1) {
          returnUrl = encodeURIComponent(svs.utils.url.currentUrlEncodedParams());
        } else {
          returnUrl = 'null'; 
        }
      } else {
        returnUrl = 'null';
      }
    }
    logger.debug('Freja eID return url: ' + returnUrl);
    return returnUrl;
  }
  function qrCodeGenerate(authRef) {
    var qrCodeId = authRef;
    if (qrCodeId !== undefined && qrCodeId.length > 0) {
      qrCodeId = getFrejaEidStartParams(authRef);
      $(function() {
        $('.qrCode')
          .empty()
          .qrcode({
            size: 120,
            color: '#3a3',
            text: qrCodeId
          });
      });
    }
  }
  svs.app.frejaeid.suspensionDefaultErrorHandler = frejaeidErrorHandler.bind(this, ACTION_TYPE.SUSPENSION);
  svs.app.frejaeid.verifySuspensionRequest = authenticate;
  svs.app.frejaeid.initAuth = initAuth;
  svs.app.frejaeid.qrCodeGenerate = qrCodeGenerate;
  svs.app.frejaeid.getFrejaEidStartParams = getFrejaEidStartParams;
})(svs);

 })(window);